import WellBeingPartnerPage from '@/components/feature/WellBeingPartnerPage/WellBeingPartnerPage'

const WellBeingPartner = () => {
  return <WellBeingPartnerPage />
}

export default WellBeingPartner
